import type { ProductFamilyOptionsType } from "../productFamily";

import { getProductsOwnedCookie } from "./getProductOwnedCookie";

export const isProductContentRestricted = (productFamily: ProductFamilyOptionsType): boolean => {
  const productsOwned = getProductsOwnedCookie();

  return !productsOwned.includes(productFamily);
};
